import { render, staticRenderFns } from "./WidgetProductions.vue?vue&type=template&id=5f335a04&"
import script from "./WidgetProductions.vue?vue&type=script&lang=js&"
export * from "./WidgetProductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports